import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { 
  Construction, 
  Users, 
  Truck, 
  Settings as SettingsIcon, 
  Terminal,
} from 'lucide-react';

export const PlaceholderPage = ({ title, description, icon: Icon = Construction }) => (
  <div className="space-y-6" data-testid={`${title?.toLowerCase().replace(/\s/g, '-')}-page`}>
    {/* Page Header */}
    <div className="flex items-center gap-3">
      <div className="p-2 rounded-lg bg-[#2563eb]/10">
        <Icon className="w-6 h-6 text-[#2563eb]" />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-foreground">{title || 'Coming Soon'}</h1>
        <p className="text-sm text-muted-foreground">{description || 'This feature is under development'}</p>
      </div>
    </div>

    {/* Coming Soon Card */}
    <Card className="max-w-2xl">
      <CardHeader className="text-center pb-2">
        <div className="mx-auto w-16 h-16 rounded-full bg-[#2563eb]/10 flex items-center justify-center mb-4">
          <Construction className="w-8 h-8 text-[#2563eb]" />
        </div>
        <CardTitle className="text-xl">Coming Soon</CardTitle>
      </CardHeader>
      <CardContent className="text-center text-muted-foreground">
        <p className="text-sm">This feature is under development and will be available soon.</p>
      </CardContent>
    </Card>
  </div>
);

export const Commands = () => (
  <PlaceholderPage 
    title="Commands" 
    description="Send GPRS commands to devices and view command logs" 
    icon={Terminal}
  />
);
